import { CanvasType, PosterType } from '@meitu/saas-editor-core/es/version-types';

export enum DownloadImgType {
    jpg = 'jpg',
    png = 'png',
    ppt = 'ppt',
    pdf = 'pdf',
}

// 判断是否是ppt
export const checkTypeIsPPT = (type: CanvasType) => {
    if (CanvasType.PPT === type) {
        return true;
    }

    return false;
};

// 判断是否是 普通 ppt
export const checkTypeIsNormalPPT = (postType: PosterType) => {
    if (PosterType.NormalPPT === postType) {
        return true;
    }

    return false;
};

// 判断是否是 ai ppt
export const checkTypeIsAiPPT = (postType: PosterType) => {
    if (PosterType.AiPPT === postType) {
        return true;
    }

    return false;
};
